<!--
没有注册轻魔方账户，小程序点进来--注册并绑定小程序/微信
注册了轻魔方账户，没有绑定微信，小程序点进来--绑定小程序/微信
-->
<template>
	<div class="register-container">
		<div
			class="register-container-wrapper"
			v-if="!pageLoading && !requestError"
		>
			<h1>{{$store.getters.webName}}</h1>
			<van-image
				round
				fit="cover"
				width="100px"
				height="100px"
				:src="phoneRegister.headImg"
			>
				<template v-slot:error>加载失败</template>
			</van-image>
			<van-field
				v-model="phoneRegister.userName"
				placeholder="请输入用户名"
				size="large"
			>
			</van-field>
			<div class="phone-container">
				<van-button
					plain
					hairline
					size="small"
					@click="showPicker = true"
				>
					{{phoneRegister.countryCode}}
					<van-icon name="arrow-down" />
				</van-button>
				<van-field
					v-model="phoneRegister.telephone"
					placeholder="请输入手机号"
					type="tel"
				>
				</van-field>
			</div>
			<div class="code-container">
				<van-field
					class="code-input"
					:maxlength="4"
					v-model="phoneRegister.code"
					placeholder="请输入短信验证码"
				>
				</van-field>
				<van-button
					:disabled="codeBtnDisable"
					size="small"
					color="#4260FA"
					:loading="phoneRegisterRetry.loading"
					loading-text="发送中..."
					@click="sendCode"
				>
					{{phoneRegisterRetry.content}}
				</van-button>
			</div>
			<van-field
				v-if="userStatus !== USER_EXIST_NOT_BIND_WECHAT"
				v-model.trim="phoneRegister.password"
				placeholder="请输入密码"
			>
			</van-field>
			<van-button
				color="#4260FA"
				block
				class="reg-btn"
				@click="submitPhoneRegister"
			>
				注册
			</van-button>
			<div class="service-laws">
				<span>点击注册表明您已阅读并同意</span>
				<a
					:href="$store.getters.configMap.termsOfServiceUrl"
					target="_blank"
				>《服务条款》</a>
			</div>
		</div>
		<div
			class="error-page"
			v-if="requestError"
		>
			获取页面数据失败
		</div>
		<van-popup
			v-model="showPicker"
			position="bottom"
		>
			<van-picker
				show-toolbar
				:columns="countryCodes"
				@cancel="showPicker = false"
				@confirm="onConfirm"
			>
			</van-picker>
		</van-popup>

	</div>
</template>

<script>
	const USER_CODE_REG = 0 // 注册
	const USER_NOT_EXIST = 0 // 不存在
	const USER_EXIST_NOT_BIND_WECHAT = 1 //  存在 未绑定微信
	const USER_EXIST_BIND_WECHAT = 2 // 存在已绑定微信
	const imageList = [
		'/apaas/form/fetch/image?id=299930108762783744.png',
		'/apaas/form/fetch/image?id=299930108762783747.png',
		'/apaas/form/fetch/image?id=299930108762783947.png',
		'/apaas/form/fetch/image?id=299930108762783950.png',
		'/apaas/form/fetch/image?id=299930108762784144.png'
	]
	export default {
		data() {
			return {
				USER_EXIST_NOT_BIND_WECHAT,
				showPicker: false,
				pageLoading: true,
				requestError: false,
				countryCodes: [
					'+86',
					'+66'
				],
				codeMap: {
					'+86': {
						content: '中国大陆+86',
						label: '+86',
						pattern: /^(\+?0?86\-?)?1[345789]\d{9}$/
					},
					'+66': {
						content: '泰国 +66',
						label: '+66',
						pattern: /(^s*)|(s*$)/g
					}
				},

				phoneRegisterRetry: {
					status: false,
					loading: false,
					content: '发送验证码'
				},
				phoneRegister: {
					countryCode: '+86',
					telephone: '',
					code: '',
					password: '',
					userName: '',
					headImg: '',
					email: '',
					inviteCode: '',
					openId: '',
					agree: true
				},
				userStatus: USER_NOT_EXIST,
				companyId: '',
			}
		},
		created() {
			this.pageLoading = true
			// '5e781bbb0071d41801002e79'  this.$route.query.key
			if (this.$route.query.pageType) {
				const {
					openId,
					nickName,
					avatarUrl
				} = this.$route.query
				this.companyId = this.$route.query.companyId
				this.phoneRegister.openId = openId
				this.phoneRegister.userName = nickName || ''
				this.phoneRegister.headImg = avatarUrl || this.arrayRandomElement(imageList)
				this.pageLoading = false
			} else {
				this.$store.dispatch('actionWechatLoginNodeGet', this.$route.query.key)
					.then(res => {
						this.phoneRegister.userName = res.nickName
						this.phoneRegister.headImg = res.avatarUrl
						this.phoneRegister.openId = res.openId
					})
					.catch(err => {
						console.error(err)
						this.requestError = true
					}).finally(() => {
						this.pageLoading = false
					})
			}
		},
		computed: {
			// 手机号是否通过验证
			phoneValidator() {
				return this.phoneRegister.telephone.length
				// && this.codeMap[this.phoneRegister.countryCode].pattern.test(`${this.phoneRegister.countryCode}${this.phoneRegister.telephone}`)
			},
			codeBtnDisable() {
				return !this.phoneValidator || this.phoneRegisterRetry.status
			}
		},
		methods: {
			// 发送验证码
			sendCode() {
				const {
					countryCode,
					telephone
				} = this.phoneRegister
				this.$store.dispatch('actionCheckUserExist', {
					countryCode,
					telephone
				}).then(resultObject => {
					if (resultObject) {
						this.userStatus = resultObject.code
						if (resultObject.code === USER_NOT_EXIST) {
							// 用户不存在
							this.doGetAuthCode()
							// this.$toast.success('短信验证码已发，10分钟内有效')
						} else if (resultObject.code === USER_EXIST_NOT_BIND_WECHAT) {
							// 存在 未绑定微信
							this.doGetAuthCode()
							// this.$toast.success('短信验证码已发，10分钟内有效')
						} else if (resultObject.code === USER_EXIST_BIND_WECHAT) {
							// 存在已绑定微信
							this.$toast.fail(`该用户已经是${this.$store.getters.webName}用户，并已绑定微信`)
						}
					}
				}).catch(console.error)
			},
			doGetAuthCode() {
				const phoneRegisterRetry = this.phoneRegisterRetry
				const retry = s => setTimeout(() => {
					if (s) {
						phoneRegisterRetry.content = `${s}s 后刷新`
						retry(--s)
					} else {
						phoneRegisterRetry.status = false
						phoneRegisterRetry.content = '重新发送'
					}
				}, 1000)
				const {
					countryCode,
					telephone
				} = this.phoneRegister

				phoneRegisterRetry.loading = true
				phoneRegisterRetry.content = ''
				this.$store.dispatch('userCodeGet', {
					countryCode,
					telephone,
					companyId: this.companyId,
					type: USER_CODE_REG
				}).then(() => {
					phoneRegisterRetry.loading = false
					phoneRegisterRetry.status = true
					phoneRegisterRetry.content = `60s 后刷新`
					retry(59)
				}).catch(() => {
					phoneRegisterRetry.loading = false
					phoneRegisterRetry.status = false
					phoneRegisterRetry.content = '重新发送'
				})
			},
			onConfirm(value) {
				this.phoneRegister.countryCode = value
				this.showPicker = false
			},
			// 提交注册
			async submitPhoneRegister() {
				if (!this.phoneValidator) {
					this.$toast.fail('手机号有误')
					return
				}
				if (!this.phoneRegister.code.length) {
					this.$toast.fail('验证码不能为空')
					return
				}
				if (this.userStatus !== USER_EXIST_NOT_BIND_WECHAT &&
					!/^[0-9a-zA-z_]{6,}$/.test(this.phoneRegister.password)) {
					this.$toast.fail('密码必须6-18位')
					return
				}
				const toast = this.$toast.loading({
					message: '申请中...'
				})
				this.$store.dispatch('userRegister', this.phoneRegister)
					.then(({
						status,
						resultObject,
						info
					}) => {
						if (status === 0) {
							// 注册成功
							this.$toast.success('注册成功')
							if (this.$route.query.pageType) {
								// 邀请加入团队注册
								// this.$store.dispatch('actionRegisterComplete', {
								//   userId: resultObject.userId,
								//   pathway: 1,
								// })
								this.jumpInvite(resultObject)
							} else {
								if (this.userStatus === USER_NOT_EXIST) {
									// 如果用户不存在，意味着是刚注册用户，就需要创建团队
									this.$store.dispatch('actionRegisterComplete', {
										userId: resultObject.userId,
										pathway: 0,
									})
									this.registerHandle(resultObject)
								} else {
									this.$wx.miniProgram.navigateBack()
								}
							}
						} else {
							this.$toast.fail(info)
						}
					}).catch(console.error)
					.finally(() => {
						toast.clear()
					})
			},
			// 邀请加入团队注册后跳转
			jumpInvite(res) {
				this.$store.dispatch('reqNodeSave', {
						inviteCode: this.$route.query.inviteCode,
						userId: res.userId,
						userName: res.userName,
						headImg: res.headImg,
						isLogin: 1
					}).then(res => {
						this.$router.push({
							name: `invite`,
							query: {
								key: res.nodeKey
							}
						})
					})
					.catch(console.error)
			},
			// 正常注册后跳转
			registerHandle(res) {
				this.$store.commit('UPDATE__USER_INFO', res)
				this.$store.commit('UPDATE__USER_ID', res.userId)
				this.$store.dispatch('reqInstallDemo')
					.then(resultObject => {
						return resultObject
					}).then(({
						companyInfo,
						taskIdList,
						tempList
					}) => {

						this.$store.dispatch('actionNodeSave', {
							taskIdList,
							userInfo: this.$store.getters.userInfo,
							tempList,
							companyInfo,
							token: this.$store.state.token
						}).then(res => {
							// 跳转到小程序安装应用页面
							this.$wx.miniProgram.redirectTo({
								url: `/pages/install_temp/index?key=${res.nodeKey}`
							})
						})
					})
					.catch(err => {
						this.$wx.miniProgram.navigateBack()
						console.log(err)
					})
			},
			arrayRandomElement(array) {
				return array[Math.floor(Math.random() * array.length)]
			}
		}
	}
</script>

<style lang="less">
	.register-container {
		width: 100%;
		height: 100%;
		position: absolute;
		background: #fff url(../../assets/images/regbg.png) no-repeat left top;
		background-size: contain;

		.register-container-wrapper {
			text-align: center;
			padding: 0 20px;

			h1 {
				font-size: 30px;
				margin-top: 80px;
				margin-bottom: 10px;
			}

			.van-image {
				margin-bottom: 30px;
			}

			.phone-container {
				display: flex;

				.van-button {
					height: 36px;
					border: 1px solid #DCDFE6;
					margin-right: 5px;
					border-radius: 5px;

					.van-button__content {
						width: 40px;
					}
				}
			}

			.van-field {
				border: 1px solid #DCDFE6;
				border-radius: 5px;
				height: 36px;
				padding: 5px 10px;
				margin-bottom: 15px;

				.van-field__control {
					font-size: 12px;
				}
			}

			.phone-container {
				margin-bottom: 5px;
			}

			.code-container {
				display: flex;
				align-items: center;
				margin-bottom: 15px;

				.code-input {
					margin-bottom: 0;
				}

				.van-button {
					width: 130px;
					margin-left: 10px;
				}
			}

			.reg-btn {
				margin-top: 40px;
			}

			.service-laws {
				text-align: right;
				font-size: 12px;
				margin-top: 10px;

				span {
					color: #91A1B7;
				}

				a {
					color: #73a5da;
					cursor: pointer;
					outline: 0;
					text-decoration: none;
				}
			}
		}

		.error-page {
			font-size: 20px;
			color: #959699;
			margin-top: 200px;
			line-height: 30px;
			text-align: center;
		}
	}
</style>
